import React from 'react';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import EventsList from './EventsList';

const EventsSettingsPage: React.FC = () => {

    const pageHeader = {
        title: 'Ajustes de Eventos',
        breadcrumb: [
            { name: 'Inicio', href: menuRoutes.dashboard.path },
            { name: 'Configuración' },
            { name: 'Eventos', href: menuRoutes.settings.path + menuRoutes.settings.events },
        ]
    };

    return (
        <div className='h-full overflow-auto scrollbar'>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
                className='border-b-4 border-dotted border-grey-500 top-0'
            />

            <div className="p-6">
                <EventsList />
            </div>
        </div>
    );
};

export default EventsSettingsPage;

